import { useEffect, useState, type ReactNode } from 'react'

const RECOMMENDATION_FUND_SHINE_GREEN = '#2A9C4A'

const recommendationFundShineLayerStyle = {
  background: `linear-gradient(105deg, transparent 44%, ${RECOMMENDATION_FUND_SHINE_GREEN}0D 46%, ${RECOMMENDATION_FUND_SHINE_GREEN}14 50%, ${RECOMMENDATION_FUND_SHINE_GREEN}0D 54%, transparent 56%)`
} as const

export function RecommendationFundTileHighlight({
  children,
  isHighlighted
}: {
  children: ReactNode
  isHighlighted: boolean
}) {
  const [shouldAnimate, setShouldAnimate] = useState(false)

  useEffect(() => {
    if (!isHighlighted) {
      setShouldAnimate(false)
      return undefined
    }
    const timeoutId = window.setTimeout(() => {
      // setShouldAnimate(true)
      setShouldAnimate(false)
    }, 300)
    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [isHighlighted])

  if (!isHighlighted) {
    return <>{children}</>
  }

  return (
    <div className="relative w-full max-w-full overflow-hidden rounded-[12px]">
      {children}
      <div
        className="pointer-events-none absolute inset-0 overflow-hidden rounded-[12px]"
        aria-hidden
      >
        <div
          className="absolute inset-0 will-change-transform"
          style={{
            ...recommendationFundShineLayerStyle,
            animation: shouldAnimate ? 'recommendation-fund-shine 1.6s ease-in-out forwards' : 'none',
            transform: 'translateX(-120%) scale(1.25)'
          }}
        />
      </div>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            @keyframes recommendation-fund-shine {
              from {
                transform: translateX(-120%) scale(1.25);
              }
              to {
                transform: translateX(120%) scale(1.25);
              }
            }
          `
        }}
      />
    </div>
  )
}
